var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "input-phone" },
    [
      _c(
        "label",
        { staticClass: "d-none sr-only", attrs: { for: _vm.id + "_country" } },
        [_vm._v("Telefon kontaktowy - prefiks")]
      ),
      _vm._v(" "),
      _c("ic-select", {
        staticClass: "input-phone__country",
        attrs: {
          id: _vm.id + "_country",
          values: _vm.countries,
          multiple: false,
          "track-by": "prefix",
          allowEmpty: false,
        },
        scopedSlots: _vm._u([
          {
            key: "singleLabel",
            fn: function ({ option }) {
              return [
                _c("span", {
                  staticClass: "input-phone__label__flag iti-flag",
                  class: option.iso,
                }),
                _vm._v(" "),
                _c("span", { staticClass: "input-phone__label__prefix" }, [
                  _vm._v(_vm._s(option.prefix)),
                ]),
              ]
            },
          },
          {
            key: "option",
            fn: function ({ option }) {
              return [
                _c("span", {
                  staticClass: "input-phone__option__flag iti-flag",
                  class: option.iso,
                }),
                _vm._v(" "),
                _c("span", { staticClass: "input-phone__option__country" }, [
                  _vm._v(_vm._s(option.name)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "input-phone__option__prefix" }, [
                  _vm._v(_vm._s(option.prefix)),
                ]),
              ]
            },
          },
        ]),
        model: {
          value: _vm.countryCode,
          callback: function ($$v) {
            _vm.countryCode = $$v
          },
          expression: "countryCode",
        },
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.phoneNumber,
            expression: "phoneNumber",
          },
        ],
        staticClass: "form-control input-phone__phone",
        attrs: {
          id: _vm.id,
          type: "phone",
          maxlength: _vm.maxlength > 0 ? _vm.maxlength : null,
        },
        domProps: { value: _vm.phoneNumber },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.phoneNumber = $event.target.value
            },
            _vm.emmitEvent,
          ],
          keyup: function ($event) {
            return _vm.cleanUpInput("phoneNumber")
          },
        },
      }),
      _vm._v(" "),
      _vm.maxlength > 0
        ? _c("span", { staticClass: "counter text-muted" }, [
            _vm._v(_vm._s(_vm.charactersLeft)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }